import * as React from 'react';
import _ = require('underscore');

import { ReactActionDialogBodyProps } from '~src/commonInfra/dialogs/ReactActionDialog';
import { OAuthCredentials } from '~src/connectivity/resources/OAuthCredentials';
import { AddOAuthCredentialAction } from '~src/connectivity/services/AddOAuthCredentialAction';
import { EditableConnection } from '~src/connectivity/services/EditConnectionDialog';
import { ListResult } from '~src/ts/fetchers/ListResult';
import { Filter } from '~src/ts/helpers/Filter';
import { SliceableHelper } from '~src/ts/helpers/SliceableHelper';
import { ResourceQuery } from '~src/ts/resources/ResourceQuery';
import { IOAuthCredential } from '~src/ts/ServerApi/types/IOAuthCredential';

import { EditOAuthConnectionDialogProps, EditOAuthConnectionDialogState } from '../../EditOAuthConnectionAction';
import { EditSalesforceConnectionDialogEmbeddedToggle } from './EditSalesforceConnectionDialogEmbeddedToggle';
import { EditSalesforceConnectionDialogPrompt } from './EditSalesforceConnectionDialogPrompt';
import { EditSalesforceConnectionDialogTestConnection } from './EditSalesforceDialogTestConnection';

export type EditSalesforceConnectionDialogBodyProps = ReactActionDialogBodyProps<
  EditOAuthConnectionDialogProps,
  EditOAuthConnectionDialogState
>;

export function EditSalesforceConnectionDialogBody(props: EditSalesforceConnectionDialogBodyProps) {

  const refreshCredentials = (
    firstConnectionType: string) => {
    const credentialsQuery: ResourceQuery<IOAuthCredential> =
      OAuthCredentials.all().addFilter(Filter.fieldEq('type', firstConnectionType));

    return SliceableHelper.fetchAll(credentialsQuery)
      .then((credentialsListResult: ListResult<IOAuthCredential>) => {
        props.updateDialogState({ credentials: credentialsListResult.items });
        return credentialsListResult; // For chaining
      });
  };

  const handleToggleChange = (credentialOptionName: string) => {
    if (credentialOptionName === 'oauth') {
      props.updateDialogState({ credentialOption: 'oauth' });
    } else if (credentialOptionName === 'password') {
      props.updateDialogState({ credentialOption: 'password', isPasswordEmbedded: true });
    } else if (credentialOptionName === 'none') {
      props.updateDialogState({ credentialOption: 'none' });
    }
  };

  const handleUserNameChange = (username: string) => {
    props.updateDialogState({ username: username });
  };

  const handlePasswordChange = (password: string) => {
    props.updateDialogState({ password: password });
  };
  const handleCredentialIdChange = (credentialId: string) => {
    if (credentialId === props.addNewOAuthCredentialOptionValue) {
      props.updateDialogState({
        credentialId: undefined,
      });
      const firstConnection: EditableConnection = props.firstConnection;
      const firstConnectionType = firstConnection.connectionType;
      const firstConnectionDetails = firstConnection.connectionDetails;
      let instanceUrl: string;
      let role: string;
      if (firstConnectionDetails.type === 'database') {
        instanceUrl = firstConnectionDetails.instanceUrl;
        role = firstConnectionDetails.role;
      }

      AddOAuthCredentialAction.attemptAuth(firstConnectionType, instanceUrl, role).then((credentialId: string) => {
        refreshCredentials(firstConnectionType).then((credentialsListResult: ListResult<IOAuthCredential>) => {
          // Set the credentialId if it exists in the list
          if (_.find(credentialsListResult.items, (credential: IOAuthCredential) => credential.id === credentialId)) {
            props.updateDialogState({
              credentialId: credentialId,
            });
          }
        });
      });
    } else {
      props.updateDialogState({ credentialId: credentialId });
    }
  };

  return (
    <>
      <EditSalesforceConnectionDialogPrompt prompt={props.prompt} />
      <div style={{ width: '100%' }}>
        <EditSalesforceConnectionDialogEmbeddedToggle
          credentialNoValueOptionText={props.dialogState.credentialNoValueOptionText}
          currentConnectionTypeDisplayName={props.currentConnectionTypeDisplayName}
          addNewOAuthCredentialOptionValue={props.addNewOAuthCredentialOptionValue}
          credentialId={props.dialogState.credentialId}
          credentials={props.dialogState.credentials}
          credentialOption={props.dialogState.credentialOption}
          username={props.dialogState.username}
          password={props.dialogState.password}
          handleToggleChange={handleToggleChange}
          handleCredentialIdChange={handleCredentialIdChange}
          handleUserNameChange={handleUserNameChange}
          handlePasswordChange={handlePasswordChange}
        />

        <EditSalesforceConnectionDialogTestConnection
          dialogState={props.dialogState}
          onTestConnection={props.testConnection}
          isTestConnectionDisabled={props.isTestConnectionDisabled(props.dialogState)}
        />
      </div>
    </>
  );
}
